const PENDIENTE = '0'
const ACTIVO = '1'
const NO_ACTIVO = '2'
const EN_BAJA = '3'
const DADO_DE_BAJA = '4'

const __dictionary = {
  [PENDIENTE]: { id: PENDIENTE, nombre: 'PENDIENTE', color: 'warning' },
  [ACTIVO]: { id: ACTIVO, nombre: 'ACTIVO', color: 'success' },
  [NO_ACTIVO]: { id: NO_ACTIVO, nombre: 'NO ACTIVO', color: 'secondary' },
  [EN_BAJA]: { id: EN_BAJA, nombre: 'EN BAJA', color: 'info' },
  [DADO_DE_BAJA]: { id: DADO_DE_BAJA, nombre: 'DADO DE BAJA', color: 'danger' }
}

const __array = [
  __dictionary[PENDIENTE],
  __dictionary[ACTIVO],
  __dictionary[NO_ACTIVO],
  __dictionary[EN_BAJA],
  __dictionary[DADO_DE_BAJA]
]

export default Object.freeze({
  PENDIENTE,
  ACTIVO,
  NO_ACTIVO,
  EN_BAJA,
  DADO_DE_BAJA,
  __dictionary,
  __array
})
